<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EWrJjs/tc-custom/9783988269232.jpg?1704425416104" alt="This image is the cover for the book The Sweeper Of Loray And Three More Stories, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Sweeper Of Loray And Three More Stories, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>This is a great collection of action short stories from "The Golden Age of Science Fiction". Featured here are four stories by Robert Sheckley: "The Sweeper Of Loray", "The Leech", "Prospector's Special", and "Forever".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Sheckley
      </h2>
      
      <p class="authorDescription body article">Robert Sheckley (1928-2005) was an American science fiction author celebrated for his wit, humor, and imaginative storytelling. He was born on July 16, 1928, in New York City, and he passed away on December 9, 2005. Sheckley's writing often explored the absurdities of human existence and societal norms, making him a prominent figure in the realm of satirical and humorous science fiction. Robert Sheckley's writings, characterized by their witty and satirical take on the human condition, continue to be appreciated for their clever storytelling and social commentary. He left a lasting impact on the science fiction genre and is remembered as a master of humorous and thought-provoking speculative fiction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4688f488